import React from 'react';
import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';
import ModalShell from '../../../components/ui/ModalShell';
import { getContentTypeDisplayName } from 'utils/contentUtils';

interface ReviewContentModalConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  contentUrl: string;
  contentType: 'image' | 'video';
  handleSubmitStory: () => void;
  handleRetry: () => void;
  isLoading: boolean;
}

const ReviewContentModalConfirmation: React.FC<ReviewContentModalConfirmationProps> = ({
  isOpen,
  onClose,
  contentUrl,
  contentType,
  handleSubmitStory,
  handleRetry,
  isLoading
}) => {
  const isVideo = contentType === 'video';
  const contentLabel = getContentTypeDisplayName(undefined, contentType === 'image' ? 'photo' : 'video');

  return (
    <ModalShell isOpen={isOpen} onClose={onClose} title={`Confirm Your ${contentLabel}`}>
          <VStack spacing="14px">
            <Text width="100%" color="#3E3E42" fontSize="16px" lineHeight="1.45">
              Please confirm this is the {contentLabel.toLowerCase()} you are submitting
            </Text>

            <Box
              width="100%"
              bg="#F2F2F0"
              borderRadius="16px" 
              overflow="hidden"
              position="relative"
            >
              {isVideo ? (
                <video 
                  key={contentUrl}
                  controls 
                  width="100%" 
                  src={contentUrl}
                  style={{ display: 'block', maxHeight: '500px' }}
                  preload="metadata"
                  playsInline
                  onError={(e) => {
                    console.error('Video failed to load:', e);
                    console.log('Video URL:', contentUrl);
                    console.log('Video type:', (e.target as HTMLVideoElement).error?.code);
                  }}
                  onLoadedMetadata={() => {
                    console.log('Video loaded successfully');
                  }}
                />
              ) : (
                <img 
                  src={contentUrl} 
                  alt={`${contentLabel} preview`}
                  style={{ 
                    width: '100%', 
                    display: 'block',
                    objectFit: 'contain',
                    maxHeight: '500px'
                  }}
                  onError={(e) => {
                    console.error('Image failed to load:', e);
                    console.log('Image URL:', contentUrl);
                  }}
                />
              )}
            </Box>

            <VStack spacing="10px" width="100%" pt="6px">
              <Button
                width="100%"
                h="56px"
                bg="#C6F432"
                color="#0E0E0E"
                borderRadius="999px"
                fontSize="17px"
                fontWeight="600"
                leftIcon={<FiCheck size={18} strokeWidth={2.8} />}
                onClick={handleSubmitStory}
                isLoading={isLoading}
                isDisabled={isLoading}
                _hover={{ bg: '#B8E62A' }}
              >
                Yes, Submit This {contentLabel}
              </Button>
              
              <Button
                width="100%"
                h="52px"
                bg="#FFFFFF"
                border="1.5px solid #0E0E0E"
                borderRadius="999px"
                color="#0E0E0E"
                fontSize="16px"
                fontWeight="600"
                onClick={handleRetry}
                isDisabled={isLoading}
                _hover={{ bg: '#F2F2F0' }}
              >
                Re-try with Another {contentLabel}
              </Button>
            </VStack>
          </VStack>
    </ModalShell>
  );
};

export default ReviewContentModalConfirmation;